// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"b7e888e6","43":"cf2d8ff6","267":"54fc6c33","345":"033f4878","412":"e10d696c","481":"0caef3d9","621":"49921121","662":"0f0cd8a0"}[chunkId] + ".chunk.css";
};